// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"a36ba95c2d80ab9316eb","223":"7f911c4ecc7d5c8a8b30","293":"623363e64a457f7c1859"}[chunkId] + ".js";
};